<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <sidebar-fixed-toggle-button v-if="roleid != 5" />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('sidebar.shortTitle')"
      :title="$t('sidebar.title')"
      v-if="roleid != 5"
    >
      <template slot="links">
        <!--admin sidebar-->
        <sidebar-item
          v-if="isLand"
          :link="{
            name: $t('sidebar.landoverview'),
            img: require('../../assets/img/eprf-home.png'),
            path: '/Land/Overview',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isVessel"
          :link="{
            name: $t('sidebar.vesseloverview'),
            img: require('../../assets/img/eprf-home.png'),
            path: '/Vessel/Overview',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isVendor"
          :link="{
            name: $t('sidebar.vendoroverview'),
            img: require('../../assets/img/eprf-home.png'),
            path: '/Vendor/Overview',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isAuthorities"
          :link="{
            name: $t('sidebar.authoritiesoverview'),
            img: require('../../assets/img/eprf-home.png'),
            path: '/Authorities/Overview',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: $t('sidebar.overview'),
            img: require('../../assets/img/eprf-home.png'),
            path: '/overview',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="isAdmin && position != 'OPERATION' 
          // && position != 'MANAGEMENT'
          "
          :link="{
            name: $t('sidebar.adminusers'),
            img: require('../../assets/img/eprf-users.png'),
            path: '/Users',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: $t('sidebar.adminhome'),
            img: require('../../assets/img/Home-incoming copy.png'),
            path: '/Incoming',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: $t('sidebar.adminpre-process'),
            img: require('../../assets/img/eprf-ship.png'),
            path: '/Preprocess',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: $t('sidebar.admininventory'),
            img: require('../../assets/img/eprf-inventory.png'),
            path: '/Inventory',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: $t('sidebar.adminoutgoing'),
            img: require('../../assets/img/eprf-lorry.png'),
            path: '/Outgoing',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="isLand"
          :link="{
            name: $t('sidebar.landjob'),
            img: require('../../assets/img/eprf-lorry.png'),
            path: '/Land/Request',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="isVessel"
          :link="{
            name: $t('sidebar.vesseljob'),
            img: require('../../assets/img/eprf-lorry.png'),
            path: '/Vessel/Request',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="isVendor"
          :link="{
            name: $t('sidebar.vendorjob'),
            img: require('../../assets/img/eprf-lorry.png'),
            path: '/Vendor/Job',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="isAuthorities"
          :link="{
            name: $t('sidebar.authoritiesjob'),
            img: require('../../assets/img/eprf-lorry.png'),
            path: '/Authorities/Job',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="isLand"
          :link="{
            name: $t('sidebar.browse'),
            img: require('../../assets/img/cart.png'),
            path: '/Land/Sales',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: $t('sidebar.sales'),
            img: require('../../assets/img/cart.png'),
            path: '/Sales',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isVessel"
          :link="{
            name: $t('sidebar.browse'),
            img: require('../../assets/img/cart.png'),
            path: '/Vessel/Sales',
          }"
        ></sidebar-item>

        <sidebar-item
          v-if="roleid == 1"
          :link="{
            name: $t('Authority'),
            img: require('../../assets/img/authority.png'),
            path: '/Authorities/Overview',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isLand"
          :link="{
            name: $t('sidebar.landcalendar'),
            img: require('../../assets/img/eprf-calendar.png'),
            path: '/Land/Calendar',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isVessel"
          :link="{
            name: $t('sidebar.vesselcalendar'),
            img: require('../../assets/img/eprf-calendar.png'),
            path: '/Vessel/Calendar',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isVendor"
          :link="{
            name: $t('sidebar.vendorschedule'),
            img: require('../../assets/img/eprf-calendar.png'),
            path: '/Vendor/Schedule',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isAuthorities"
          :link="{
            name: $t('sidebar.authoritiesschedule'),
            img: require('../../assets/img/eprf-calendar.png'),
            path: '/Authorities/Schedule',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: $t('sidebar.admincalendar'),
            img: require('../../assets/img/eprf-calendar.png'),
            path: '/Calendar',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="roleid == 1"
          :link="{
            name: $t('sidebar.adminform'),
            img: require('../../assets/img/eprf-forms.png'),
            path: '/Forms',
          }"
        >
        </sidebar-item>
        <!-- <sidebar-item
          v-if="roleid == 1 && (position == 'ADMIN MAIN' || position == 'MANAGEMENT')"
          :link="{
            name: $t('sidebar.adminreport'),
            img: require('../../assets/img/eprf-forms.png'),
            path: '/Reports',
          }"
        >
        </sidebar-item> -->
      </template>
    </side-bar>

    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import SidebarShare from "./SidebarSharePlugin";
import util from "../../util/util";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import SidebarFixedToggleButton from "./SidebarFixedToggleButton.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      roleid: "",
      land: {
        overview: false,
        myjob: false,
        calendar: false,
        forms: false,
      },

      vendor: {
        overview: false,
        myjob: false,
        schedule: false,
      },

      authorities: false,
      sso: {
        fleet: false,
        greenCard: false,
        incident: false,
        attendance: {
          all: false,
          overview: false,
          anal: false,
          overallreport: false,
          sumreport: false,
          mobilereport: false,
          empmanage: false,
          shiftcode: false,
          scheduleedit: false,
        },
        asset: false,
        cems: false,
        cmms: false,
        scada: false,
        weigbrige: false,
      },
      isAdmin: false,
      isLand: false,
      isVessel: false,
      isVendor: false,
      isAuthorities: false,

      isSupervisor: false,

      adminToken: "",

      email: "",

      decodedToken: "",

      role: "",
      position: "",
    };
  },
  methods: {
    getToken() {
      let jwt_token = this.$cookie.get("token").split(".")[1];
      console.log(jwt_token);
      if (this.role == "Customer - Land Generator") {
        this.isAdmin = false;
        this.isLand = true;
        this.isVessel = false;
        this.isVendor = false;
        this.isAuthorities = false;
      } else if (this.role == "Customer - Vessel Generator") {
        this.isAdmin = false;
        this.isLand = false;
        this.isVessel = true;
        this.isVendor = false;
        this.isAuthorities = false;
      } else if (this.role === "Vendor") {
        this.isAdmin = false;
        this.isLand = false;
        this.isVessel = false;
        this.isVendor = true;
        this.isAuthorities = false;
      } else if (this.role === "Authorities") {
        this.isAdmin = false;
        this.isLand = false;
        this.isVessel = false;
        this.isVendor = false;
        this.isAuthorities = true;
      } else {
        this.isAdmin = true;
        this.isLand = false;
        this.isVessel = false;
        this.isVendor = false;
        this.isAuthorities = false;
      }
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      // let isWindows = navigator.platform.startsWith("Win");
      // if (isWindows) {
      //   // if we are on windows OS we activate the perfectScrollbar function
      //   initScrollbar("sidebar");
      //   initScrollbar("main-panel");
      //   initScrollbar("sidebar-wrapper");

      //   docClasses.add("perfect-scrollbar-on");
      // } else {
        docClasses.add("perfect-scrollbar-off");
      // }
    },
  },
  mounted() {
    this.email = sessionStorage.getItem("email-login");

    this.initScrollbar();
    // console.log("token ", this.adminToken);

    // console.log("decoded token", this.decodedToken.role);

    this.decodedToken = util.decodedToken();
    this.role = this.decodedToken.role;
    this.position = this.decodedToken.position.toUpperCase();
    console.log('position dia', this.position);
    this.getToken();
  },
  created() {
    this.roleid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1])).role_id
    );

    this.adminToken = localStorage.getItem("token");
    this.getToken();
  },
};
</script>
<style lang="scss">
.test {
  background-image: require("../../assets/img/People.png");
}

$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
